import { fetchLink, Link } from '@padlet/arvo'
import {
  BeethovenDisplayAttributes,
  BeethovenDisplayOptions,
  getDisplayAttributes as originalGetDisplayAttributes,
} from '@padlet/beethoven-client'
import memoize from 'lodash.memoize'

const memoizedFetchLink = memoize(fetchLink)

async function getDisplayAttributes(
  url: string,
  options: BeethovenDisplayOptions,
): Promise<BeethovenDisplayAttributes | null> {
  const link: Link | null = await memoizedFetchLink(url)
  if (!link) return null
  return originalGetDisplayAttributes(link, options)
}

export { getDisplayAttributes }
